import { render, staticRenderFns } from "./Config-yzxml.vue?vue&type=template&id=72137790&scoped=true&"
import script from "./Config-yzxml.vue?vue&type=script&lang=js&"
export * from "./Config-yzxml.vue?vue&type=script&lang=js&"
import style0 from "./Config-yzxml.vue?vue&type=style&index=0&id=72137790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72137790",
  null
  
)

export default component.exports